import { useQuery } from '@tanstack/react-query'
import type { ClinicSummaryResponse } from '@type/clinicSummary.type'
import { AXIOS_INSTANCE } from '../api'

type Props = {
  start_date?: string
  end_date?: string
  enabled?: boolean
}

export const useClinicSummary = ({ start_date, end_date, enabled = true }: Props) => {
  const ready = Boolean(start_date && end_date)

  const { data, isLoading, isError, error, refetch, isFetching } = useQuery({
    enabled: enabled && ready,
    queryKey: ['clinic_summary', { start_date, end_date }],
    queryFn: async () => {
      const { data: response } = await AXIOS_INSTANCE.get<ClinicSummaryResponse>('reports/clinic_summary', {
        params: { start_date, end_date }
      })
      return response
    },
    retry: false
  })

  return {
    summary: data?.data,
    summaryIsLoading: isLoading || isFetching,
    summaryIsError: isError,
    summaryError: error,
    refetchSummary: refetch
  }
}
